import { useContextWithValidation } from '@adsk/alloy-react-context';
import { SuspenseContext } from '@adsk/alloy-react-suspense';

export const useCheckSuspenseSetup = ({
  internalUsage,
}: {
  internalUsage: boolean;
}) => {
  useContextWithValidation(SuspenseContext, {
    hook: 'useTranslation',
    provider: 'AlloySuspense',
    shouldThrowError: internalUsage,
  });
};
